/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'card': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M128 360.864c9.44-5.472 20.288-8.864 32-8.864h736c35.36 0 64 28.64 64 64v183.136c19.04-11.072 32-31.488 32-55.136V288H128v72.864zM928 128H192c-35.36 0-64 28.64-64 64v64h864v-64c0-35.36-28.64-64-64-64zM32 480v352c0 35.36 28.64 64 64 64h512V416H96c-35.36 0-64 28.64-64 64zm800-64H672v480h160c35.36 0 64-28.64 64-64V480c0-35.36-28.64-64-64-64z"/>'
  }
})
